export { default as UfoIcon } from '~icons/tabler/ufo';
